// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-brlnm{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-ldjqb{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-vpgwu{grid-column:span 6}.assets-scss-gridstyleGrid-col3-ycsxo{grid-column:span 3}.assets-scss-gridstyleGrid-col4-txmpk{grid-column:span 4}.assets-scss-gridstyleGrid-col9-esrez{grid-column:span 9}.assets-scss-gridstyleGrid-col12-bxiqd{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-cndpq{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-brlnm",
	"grid": "assets-scss-gridstyleGrid-grid-ldjqb",
	"col6": "assets-scss-gridstyleGrid-col6-vpgwu",
	"col3": "assets-scss-gridstyleGrid-col3-ycsxo",
	"col4": "assets-scss-gridstyleGrid-col4-txmpk",
	"col9": "assets-scss-gridstyleGrid-col9-esrez",
	"col12": "assets-scss-gridstyleGrid-col12-bxiqd",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-cndpq"
};
module.exports = ___CSS_LOADER_EXPORT___;
